import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize Navigation Swiper carousels
 */
export function initNavigationSwiper() {
	$('nav.swiper').each(function () {
		const $nav = $(this);
		const navId = $nav.attr('id');

		if (navId) {
			new Swiper(`#${navId}`, {
				a11y: {
					enabled: true,
					slideRole: 'listitem',
				},
				freeMode: {
					enabled: true,
					sticky: true,
				},
				navigation: {
					nextEl: `.swiper-button-next-${navId}`,
					prevEl: `.swiper-button-prev-${navId}`,
				},
				breakpoints: {
					0: {
						spaceBetween: 10,
						slidesPerView: 1.5,
					},
					640: {
						spaceBetween: 10,
						slidesPerView: 2.5,
					},
					1024: {
						spaceBetween: 20,
						slidesPerView: 3.5,
					},
					1200: {
						spaceBetween: 20,
						slidesPerView: 4,
					},
					1440: {
						spaceBetween: 20,
						slidesPerView: 4.5,
					},
				},
			});

			// Set equal height for nav cards
			function setNavCardHeight() {
				$(`#${navId} .nav-card`).css('min-height', '');
				let maxHeight = 0;
				$(`#${navId} .nav-card`).each(function () {
					const height = $(this).outerHeight();
					if (height > maxHeight) {
						maxHeight = height;
					}
				});
				$(`#${navId} .nav-card`).css('min-height', maxHeight + 'px');
			}

			requestAnimationFrame(setNavCardHeight);
			setTimeout(setNavCardHeight, 100);
			$(window).on('resize', setNavCardHeight);
			$(window).on('load', setNavCardHeight);

			// Recalculate when images load
			$(`#${navId}`).find('img').on('load', setNavCardHeight);
		}
	});

	// Close all nav card details when Escape is pressed
	$(document).on('keydown', function (e) {
		if (e.key === 'Escape') {
			$('nav.swiper details').each(function () {
				this.open = false;
			});
		}
	});
}
